import { createSelector } from '@reduxjs/toolkit';

const selectUsersState = (state: any) => state.user;

export const selectUsersSelector = createSelector(
  [selectUsersState],
  (user) => user?.users || []
);

export const selectUserLoading = createSelector(
  [selectUsersState],
  (user) => user?.loading
);

export const selectUserById = (id: string) => createSelector(
  [selectUsersSelector],
  (user) => user?.find((user: any) => user._id === id)
);
